import { UserRolesService } from '../../../../services/user.roles.service';
import { SortBot } from '../../../../helpers/sort';
import { LicenseManager } from '../../../../managers/License.manager';
import { LiveHubService } from './../../../../services/livehub.service';
import { Component, OnInit, Input } from '@angular/core';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { clientFilesFilter } from '../../../../pipes/filter.pipe';
import { ssApiService } from '../../../../services/ss-api.service';
import { WMIItemArray } from '../../../../models/livehub/wmi';
import { AdminHubListRequest } from '../../../../models/ss-api/requests/admin.hub.list.request';

@Component({
    selector: 'wmi-data',
    templateUrl: './wmi.data.component.html',
    styleUrls: ['./wmi.data.component.scss']
})

export class WMIDataComponent implements OnInit {
    IsBusy: boolean = false;

    @Input('licenseManager') licenseManager: LicenseManager;
    @Input('Subscriptions') Subscriptions;

    // WMI Data
    WMIData: WMIItemArray = new WMIItemArray();
    CustomWMIQuery: string;

    constructor(private liveHub: LiveHubService, private sweetAlert: SweetAlertService, private clientFilesFilter: clientFilesFilter, private api: ssApiService, public roles: UserRolesService) { }

    ngOnInit() {
        // this.IsBusy = true;
        this.InitWMIData();
    }

    InitWMIData() {
        let disposable = this.liveHub.WMIBrowseResponse.subscribe(response => {
            this.WMIData = response.Result;
            this.IsBusy = false;
        });

        this.Subscriptions.push(disposable);
    }

    RequestSystemInfo(query) {
        this.IsBusy = true;
        let request: AdminHubListRequest = {
            LicenseKey: this.licenseManager.License().Key,
            Command: query,
            Method: 'WMI Query',
            MaxResults: 100,
            Offset: 0
        };
        this.liveHub.InvokeConnection('BrowseLicenseWMI', request);
    }

    SortWMIBy(sortVar1: string, sortVar2: string = '') { this.WMIData = SortBot.SortAuto(this.WMIData, sortVar1, sortVar2); }

}
